import { Grid, TextField } from "@mui/material";
import React from "react";
import RolesMultiSelect from "./RolesMultiSelect";
import Dragger from "antd/lib/upload/Dragger";
import { InboxOutlined } from "@ant-design/icons";

const TrainingItemForm = ({
  trainingItem,
  setTrainingItem,
  errors,
  roles,
  setRoles,
}) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setTrainingItem((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSelect = (value) => {
    setTrainingItem((prev) => ({
      ...prev,
      training_roles: value?.map((item) => ({ id: Number(item?.value) })),
    }));
    setRoles(value);
  };

  const handleBeforeUpload = (file) => {
    setTrainingItem((prevUser) => ({
      ...prevUser,
      file: file,
      fileName: file.name,
    }));
    return false;
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid xs={4} item>
          <TextField
            required
            fullWidth
            value={trainingItem?.sequenceId}
            name="sequenceId"
            label="Sequence Number"
            variant="outlined"
            error={errors?.sequenceId}
            helperText={errors?.sequenceId}
            onChange={handleChange}
            InputLabelProps={{
              shrink: trainingItem?.sequenceId,
            }}
          />
        </Grid>
        <Grid xs={8} item>
          <TextField
            required
            fullWidth
            value={trainingItem?.title}
            name="title"
            label="Title"
            variant="outlined"
            error={errors?.title}
            helperText={errors?.title}
            onChange={handleChange}
            InputLabelProps={{
              shrink: trainingItem?.title,
            }}
          />
        </Grid>
        <Grid xs={12} item>
          <TextField
            fullWidth
            value={trainingItem?.description}
            multiline
            rows={2}
            name="description"
            label="Description"
            variant="outlined"
            onChange={handleChange}
            sx={{ height: "auto", "& .MuiInputBase-root": { height: "auto" } }}
            InputLabelProps={{
              shrink: trainingItem?.description,
            }}
          />
        </Grid>
        <Grid xs={12} item>
          <RolesMultiSelect
            roles={roles}
            handleSelect={handleSelect}
            errors={errors}
          />
        </Grid>
        <Grid xs={12} item>
          <Dragger
            beforeUpload={handleBeforeUpload}
            multiple={false}
            showUploadList={trainingItem?.file ? true : false}
            accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.ppt,.pptx"
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined style={{ color: "var(--main-theme-color)" }} />
            </p>
            <p className="ant-upload-text">
              Click or drag file to this area to upload
            </p>
            <p className="ant-upload-hint">
              Supports PDF, Word, Excel documents
            </p>

            {trainingItem?.fileName && (
              <div style={{ margin: "16px 0" }}>
                <strong>Selected:</strong> {trainingItem?.fileName}
              </div>
            )}
            {errors?.fileName && (
              <div style={{ margin: "16px 0", color: "#d32f2f" }}>
                <strong>{errors?.fileName}</strong>
              </div>
            )}
          </Dragger>
        </Grid>
      </Grid>
    </>
  );
};

export default TrainingItemForm;
